import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import SubNav from '../components/SubNav/SubNav';

export default function (ComposedComponent) {
  class ShowLoading extends Component {

    render() {
      if (this.props.isAccountEmpty === null) {
        return (
          <div id="loading-wrapper">
            <div id="loading-text">LOADING</div>
            <div id="loading-content"></div>
          </div>
        );
      } else if (this.props.isAccountEmpty) {
        return (
          <Fragment>
            <SubNav />
            <div id="empty-account">
              <h1>You have no portfolios.</h1>
            </div>
          </Fragment>
        );
      }

      return <ComposedComponent {...this.props} />
    }
  }

  function mapStateToProps({ session }) {
    return {
      isAccountEmpty: session.isAccountEmpty
    };
  }

  return connect(mapStateToProps)(ShowLoading);
}